export type PlatformCostProviderId =
    | 'gcp'
    | 'twilio'
    | 'openai'
    | 'anthropic'
    | 'deepgram'
    | 'stripe'
    | 'fireworks'
    | 'manychat';

export type PlatformCostIngestionMode = 'api_sync' | 'manual_entry' | 'unavailable';

/**
 * A provider is syncable when a fetch adapter exists for it in the server-side
 * provider registry. `providerRegistryMatchesCatalog` asserts the two agree.
 */
export const SYNCABLE_PLATFORM_COST_PROVIDER_IDS = [
    'twilio',
    'openai',
    'gcp',
    'fireworks',
] as const satisfies readonly PlatformCostProviderId[];

export type SyncablePlatformCostProviderId = (typeof SYNCABLE_PLATFORM_COST_PROVIDER_IDS)[number];

/**
 * The word a provider uses for the thing it bills against — Twilio subaccounts,
 * OpenAI projects. Drives generated UI copy so a new provider reads correctly
 * without hand-written label sets.
 */
export type PlatformCostProviderResourceNoun = {
    singular: string;
    plural: string;
};

export type PlatformCostProviderCatalogEntry = {
    id: PlatformCostProviderId;
    name: string;
    description: string;
    resourceNoun: PlatformCostProviderResourceNoun;
    /** Nested billed unit under resourceNoun, e.g. API keys under OpenAI projects. */
    childResourceNoun: PlatformCostProviderResourceNoun | null;
    ingestionMode: PlatformCostIngestionMode;
};

export type GetPlatformCostProviderCatalogEntryParams = {
    providerId: PlatformCostProviderId;
};
